import { render } from "./BundleProducts.vue?vue&type=template&id=b662bab6&scoped=true"
import script from "./BundleProducts.vue?vue&type=script&lang=js"
export * from "./BundleProducts.vue?vue&type=script&lang=js"

import "./BundleProducts.vue?vue&type=style&index=0&id=b662bab6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b662bab6"]])

export default __exports__